module.exports = __webpack_public_path__ + "static/img/pro9_tab5.6e1c63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro9_tab5.jpg
// module id = 9pP1
// module chunks = 171